

import { Injectable } from '@angular/core';

import { Api } from '../api/api';
import { LoadingController } from '@ionic/angular';
import { AlertController } from '@ionic/angular';
import {Router} from '@angular/router';
import {__await} from 'tslib';
import { ToastController } from '@ionic/angular';

// import { FileTransferObject } from '@awesome-cordova-plugins/file-transfer/ngx';
// import { File } from '@awesome-cordova-plugins/file/ngx';
// import {Zip} from '@ionic-native/zip/ngx';
// import { CapacitorUpdater } from 'capacitor-updater'
//import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';
// import { FilePath } from '@awesome-cordova-plugins/file-path/ngx';


/**
 * Most apps have the concept of a User. This is a simple provider
 * with stubs for login/signup/etc.
 *
 * This User provider makes calls to our API at the `login` and `signup` endpoints.
 *
 * By default, it expects `login` and `signup` to return a JSON object of the shape:
 *
 * ```json
 * {
 *   status: 'success',
 *   user: {
 *     // User fields your app needs, like 'id', 'name', 'email', etc.
 *   }
 * }Ø
 * ```
 *
 * If the `status` field is not `success`, then an error is detected and returned.
 */
@Injectable()
export class User {
  public loading:any;
  public USER: any;
  public ST: any = window.localStorage
  constructor(public api: Api, public loadingController: LoadingController , public alertController: AlertController, private router: Router,private toastController: ToastController) {
    this.getUser();
  }
  public account: { mobile: string ,configed:boolean,balance:number,login : boolean, spUser: boolean , userKey: string, version: string , name: string,validate:string,email:string,viewCount:number,img:string,rid:string,them:string,themBc:string} = {
      login: false,
      configed:false,
      mobile : '',
      spUser: false,
      userKey: '',
      version: '',
      name: '',
      validate: '',
      balance:0,
      email: '',
      img:'nopic',
      viewCount:1,
      rid:'',
      them:'t1',
      themBc:'false',
  };
  // async presentAlert(msg: string) {
  //   const alert = await this.alertController.create({
  //     title: 'پیام',
  //     // subTitle: 'Subtitle',
  //     message: msg,
  //     buttons: [{
  //       text: 'تایید',
  //       handler: () => {
  //         window.open('https://data.sazejoo.com/static/sazejoo.apk', '_system', 'location=yes');
  //       }}]
  //   });
  //
  //   await alert.present();
  // }
  /**
   * Send a POST request to our login endpoint with the data
   * the user entered on the form.
   */
  async myToast(message:string,position: 'top' | 'middle' | 'bottom'="top") {
    const toast = await this.toastController.create({
      message: message,
      duration: 3000,
      position: position,
      cssClass: 'custom-toast',
    });

    await toast.present();
  }
  getUser() {
    
    // this.account.code = this.ST.getItem('code');
    this.account.mobile = this.ST.getItem('mobile');
    this.account.configed = this.ST.getItem('configed');
    this.account.userKey = this.ST.getItem('userKey');
    this.account.spUser = this.ST.getItem('spUser');
    this.account.name = this.ST.getItem('name');
    this.account.balance = null;
    this.account.email = this.ST.getItem('email');
    this.account.img = this.ST.getItem('img');
    this.account.validate = this.ST.getItem('validate');
    this.account.viewCount = this.ST.getItem('viewCount')*1;
    this.account.login = (this.ST.getItem('login') == 'true');
    this.account.version = '9.0.7';
    this.account.rid = this.ST.getItem('rid');
    this.account.them = this.ST.getItem('them')?this.ST.getItem('them'):this.account.them;
    this.account.themBc = this.ST.getItem('themBc')?this.ST.getItem('themBc'):this.account.themBc;
    return this.account;
  }
  
 
  checkLogin(suc: any , er: any) {
    const accountInfo = this.getUser();
    const seq = this.api.post('checkLogin', accountInfo);


    seq.subscribe((res: any) => {
      // If the API returned a successful response, mark the user as logged in
      if (res.status === 'success') {
      } else if (res.status === 'invalidVersion') {
        // this.presentAlert('لطفا ورژن جدید را دریافت نمایید');
      } else {

      }
      suc(res);
    }, err => {
      console.log('ERROR', err);
      er();
    });



    return seq;
  }
    perNum = ['۰|۰|٠', '۱|١|١', '۲|۲|٢', '۳|۳|٣', '۴|۴|٤', '۵|۵|٥', '۶|۶|٦', '۷|۷|٧', '۸|۸|٨', '۹|۹|٩','٫'];
    enNum = [ '0', '1', '2', '3', '4', '5', '6', '7', '8', '9','.'];
    convertPersianNum ( str : any ){
        str = String(str);
        for(var i = 0 ; i < this.perNum.length ; i++) {
            const reg = new RegExp(this.perNum[i] , 'g' );
            str = str.replace(reg, this.enNum[i]);
        }
        return (str);
    }
  clear() {
    this.account.login=false;
    this.ST.setItem('login', false);
    this.account.mobile = '';
    this.ST.setItem('mobile', '');
    this.account.configed=false
    this.ST.setItem('configed', false);
    this.account.userKey = '';
    this.ST.setItem('userKey', '');
    this.account.spUser = false;
    this.ST.setItem('spUser', '');
    this.ST.setItem('name', '');
    this.ST.setItem('email', '');
    this.ST.setItem('img', 'nopic');
    this.ST.setItem('viewCount', 1);
    this.ST.setItem('validate', '');
    this.ST.setItem('rid', '');
    this.ST.setItem('them', 't1');
    this.ST.setItem('themBc', 'false');
  }
  checkCode(accountInfo: any, suc: any, er: any) {
      this.myLoading();
      const seq = this.api.post('checkActivationCode', accountInfo);


      seq.subscribe((res: any) => {

          console.log('seq', res);
          if (res.status === '0' || res.status === '4') {
            // this._loggedIn(res);
            this.ST.setItem('login', true);
            this.ST.setItem('mobile', accountInfo.mobile);
            // this.ST.setItem('code', accountInfo.code);
            this.ST.setItem('userKey', res.data.userKey);
            this.ST.setItem('spUser', res.data.spUser);
            this.ST.setItem('name', res.data.name);
            this.ST.setItem('email', res.data.email);
            this.ST.setItem('img', res.data.img);
            this.ST.setItem('validate', res.validate);
            this.ST.setItem('rid', res.data.rid);
            this.getUser();
            this.dismissLoading();
            suc(res);
          } else {
              this.dismissLoading();
              suc(res);
          }

      }, err => {
          this.dismissLoading()
          console.log('ERROR', err);
          er();
      });

      return seq;
  }
  login(accountInfo: any, suc: any, er: any) {
    this.myLoading();
    // let seq = this.api.post('login', accountInfo).share();
    const seq = this.api.post('sendActivationCode', accountInfo).subscribe((res: any) => {
      this.dismissLoading()
      console.log('seq', res);
      // If the API returned a successful response, mark the user as logged in
      // if (res.status === '0') {
      //   // this._loggedIn(res);
      //   this.ST.setItem('login', true);
      //   this.ST.setItem('mobile', accountInfo.mobile);
      //   this.ST.setItem('code', accountInfo.code);
      //   this.ST.setItem('userKey', res.userKey);
      //   this.ST.setItem('spUser', res.spUser);
      //
      //
      // } else {
      // }
      suc(res);
    }, err => {
        this.dismissLoading()
      console.log('ERROR', err);
      er();
    });

    return seq;
  }

  /**
   * Send a POST request to our signup endpoint with the data
   * the user entered on the form.
   */

  signup(accountInfo: any,clb:any) {
    const seq = this.api.post('signup', accountInfo);

    seq.subscribe((res: any) => {
      // If the API returned a successful response, mark the user as logged in
        clb(res);
    }, err => {
      console.error('ERROR', err);
    });

    return seq;
  }

  /**
   * Log the user out, which forgets the session
   */
  logout() {
    this.USER = null;
  }

  /**
   * Process a login/signup response to store user data
   */
  _loggedIn(resp:any) {
    this.USER = resp.user;
  }
    async myLoading(text = 'درحال بارگذاری') {
        if(this.loading){
            this.loading.dismiss();
        }
        this.loading =await   this.loadingController.create({
            message: text,
        });
        this.loading.present();
    }
    dismissLoading (suc=()=>{}) {
          setTimeout(() => {
            
            try{
            this.loading.dismiss();
            }catch(e){
              console.log("loading bug")
              this.dismissLoading(suc)
            }
            suc()
          }, 500);
    }
    async myAlert( subtitle = '' , message = '' , buttons: any  = ['تایید'] , header = 'پیام' ) {
        const alert = await this.alertController.create({
            'header': header,
            'subHeader': subtitle,
            'message': message,
            'buttons': buttons
        });

        await alert.present();
    }
    public navigateByUrl(url:string){
        this.router.navigate([url]);
    }
    public getUrl(){
        return this.router.url
    }


    public checkStatus=async (res:any,success:any,failed:any)=>{
      if(res["balance"]){
        // console.log("bb",res["balance"])
        this.account.balance=res["balance"]
      }
      // console.log("dataDirectory",this.file.applicationDirectory )
        // alert(this.file.applicationStorageDirectory)
        
        // this.file.removeFile(this.file.applicationDirectory+"public","index.html").then(()=>alert("del")).catch(e=>alert(JSON.stringify(e)))
        
        // this.filePath.resolveNativePath(this.file.dataDirectory+"index.html")
        // .then(filePath => console.log("filePath", JSON.stringify(filePath) ))
        // .catch(err =>  alert("err"));
        // var uri = encodeURI("https://iaramis.com/update.zip");
        // var filePath = this.file.dataDirectory+"update.zip";
        // var zip=this.zip;
        // var file=this.file;
        // // var dfile=this.file.dataDirectory.replace("files/","")
        // alert(JSON.stringify(await Filesystem.readdir({
        //     path: '/files',
        //     directory: Directory.Data,
        // })))
        // alert(Directory.Data)
        // alert(this.file.dataDirectory)
        // return false
        // alert(this.file.dataDirectory+"files")
        // file.listDir(Directory.Documents,"").then((res)=> {
        //     for (var r in res)
        //         alert("check:" + JSON.stringify(res[r]))
        //     file.removeRecursively("resources","").then((res)=>{
        //         alert('removed')
        //
        //
            // this.transfer.download(uri, filePath,  false, {
            //         headers: {
            //             "Authorization": "Basic dGVzdHVzZXJuYW1lOnRlc3RwYXNzd29yZA=="
            //         }
            //     }
            // ).then(
            //     function(entry) {
            //         alert(JSON.stringify(entry))
            //         //alert('file is downloaded, now we are going to UNZIP IT');
            //         zip.unzip(entry.nativeURL,file.applicationDirectory, function(){
        
            //         }).then(function(){

            //           document.location.reload();
            //         }).catch(function(error){

            //           alert('مشکل zip')
            //           alert(error.message)      
            //         })
        
            //     }
            // ).catch( function(error) {
            //     alert('مشکل')
            //     alert(error.message)
            //     // toastr.warning($scope.toastrText, 'مشکل در بروز رسانی با بخش پشتیبانی تماس بگیرید',{
            //     //     timeOut: 50000
            //     // });
            //     // alert(JSON.stringify(error));
            // });

        if ( res['status'] === '0' ) {
            this.account.validate=res['validate']
            this.ST.setItem('validate', res['validate']);
            success(res);
        } else if(res['status'] === '1') {
            success(res);
        }else if(res['status'] === '2') {
            this.clear();
            this.getUser();
            // this.myAlert('', res['message'] );
            this.navigateByUrl('welcome' );
            failed(res);
        } else if(res['status'] === '3') {
            failed(res);
            this.myAlert('', res['message'] );
        } else if(res['status'] === '4') {
            failed(res);
            this.myAlert('عدم اعتبار',  res['message'] );
            this.navigateByUrl('market');
        } else if(res['status'] === '5') {
            failed(res);
            this.myAlert('ورژن نرم افزار', res['message']);
        }
    }
}

